import Dialog from "@/components/ui/dialog";
import { Wrapper } from "./Wrapper";

export const NotificationSettings = () => {
  return (
    <Dialog id="QdziCeYhAKE11aW0yj5cP">
      <Dialog.Content className="tw-rounded-lg tw-bg-white tw-shadow-none">
        <Wrapper />
      </Dialog.Content>
    </Dialog>
  );
};
